import { useNavigate } from 'react-router-dom';

import { integerToCurrency } from 'helpers';
import type { ReturnRequestItem as ReturnRequestItemType } from 'types';
import { RETURN_REQUEST_STATUS_OPTIONS, ReturnRequestStatus } from 'types';

interface ReturnRequestItemProps {
  item: ReturnRequestItemType;
}

export function ReturnRequestItem({ item }: ReturnRequestItemProps) {
  const {
    protocol,
    consignmentCode,
    value: { value: returnValue },
    createdDate,
    status,
  } = item;

  const navigate = useNavigate();

  const statusBgColorClassName =
    status === ReturnRequestStatus.Open ? 'bg-warning-500' : 'bg-success-500';

  return (
    <div
      className="flex flex-wrap justify-between min-w-[725px] xl:grid xl:grid-cols-5 gap-4
        items-center p-4 rounded-lg bg-neutral-200"
    >
      <div className="w-48">
        <p className="text-sm font-bold text-neutral-700">
          Protocolo {protocol}
        </p>
        <p className="text-xs text-neutral-700">Remessa {consignmentCode}</p>
      </div>

      <div className="w-28">
        <p className="text-xs font-bold text-neutral-700">Valor</p>
        <p className="text-sm text-neutral-700">
          {integerToCurrency(returnValue)}
        </p>
      </div>

      <div className="w-32">
        <p className="text-xs font-bold text-neutral-700">Data de criação</p>
        <p className="text-sm text-neutral-700">
          {new Date(createdDate).toLocaleDateString('pt-BR')}
        </p>
      </div>

      <div className="justify-self-start">
        <div className={`px-2 py-1 rounded-lg ${statusBgColorClassName}`}>
          <p className="text-xs font-bold text-neutral-100">
            {RETURN_REQUEST_STATUS_OPTIONS.find(
              option => option.value === status
            )?.label || status}
          </p>
        </div>
      </div>

      <div className="justify-self-end">
        <button
          className="px-4 py-2 rounded-lg bg-primary-300 text-sm text-neutral-100"
          onClick={() => navigate(`/devolucoes-e-estornos/${protocol}`)}
        >
          Acessar
        </button>
      </div>
    </div>
  );
}
